<template>
    <div class="relative radius-large" v-click-outside="closeWindow">
        <button class="btn wide mr-3" @click="toggleWindow">
            <i class="ico-add large"></i>
            New Agent
        </button>

        <div class="floating-menu shaded" v-if="showWindow">
            <h5>Search for agents</h5>

            <div class="form-group mb-2">
                <input
                    class="w-100 fs-small"
                    type="email"
                    v-model.trim="form.email"
                    @input="searchInputChanged"
                    placeholder="e.g. guide@pluralo.com">
                    
                <div v-if="hasMoreInfo && form.email.length > 0" class="d-flex align-items-center mt-1 ml-1">
                    <i class="ico ico-alert color-1 mr-1 fs-normal"></i>
                    <span class="color-1 bold fs-small"> Refine your search to reveal more results</span>
                </div>
            </div>

            <div class="dark fs-small normal">
                <div v-if="form.email.length > 0">
                    <div v-if="filteredAgents.length > 0" class="agentList">
                        <div class="darker my-3 font-weight-600">Select to Add</div>

                        <div class="row w-100 mx-0 mb-2 justify-content-between mt-1" v-for="agent in filteredAgents">
                            <div class="d-flex w-25" v-if="agent.image && agent.image != ''">
                                <div class="bg-medium h-100 w-100 radius-normal imageCoverCenter" :style="{ 'background': 'url('+agent.image+')' }">
                                </div>
                            </div>

                            <div class="w-50 pointer" @click="openAgentInfo(agent)">
                                <div class="darkest hoverLink">{{agent.brandName}}</div>
                                <div class="fs-smaller">
                                    <span v-if="agent.location">{{agent.location + ', '}}</span>
                                    <span v-if="agent.place && agent.country && agent.country.name"> , </span>
                                    <span v-if="agent.country && agent.country.name">{{agent.country.name}}</span>
                                </div>
                            </div>

                            <div>
                                <button v-if="agent.helperAlreadyAdded" class="btn tertiary opacity-50" disabled>Added</button>
                                <div v-else>
                                    <button class="connectStatusButton btn text-capitalize" :disabled="agent.isConnecting && agent.isConnecting" :class="connectButtonClass(agent)" @click="invite(agent)">{{agent.isConnecting && agent.isConnecting == true? 'Connecting': connectButtonLabel(agent)}}</button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div>
                        <form class="shaded" @submit.prevent.stop="invite">
                            <input type="submit" class="btn blue wide full mt-4" value="Create New">
                        </form>
                    </div>
                </div>
                
                <div v-else>
                    Search for a agent in Pluralo by name or email address, or enter an email address to invite someone new.
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
    import { required, email } from 'vuelidate/lib/validators'
    import { peopleMixin } from '@/mixins/people'

    export default {
        mixins:[
            peopleMixin
        ],
        data() {
            return {
                showWindow: false,
                searched: false,
                found: false,
                foundAgents: null,
                form: {
                    email: '',
                    brandName: '',
                    place: '',
                    saveAndSend: true,
                },
                filteredAgents: [],
                hasMoreInfo: false
            }
        },
        created() {
            this.resetNewAgentSetup();
            this.downloadCommunityAgents();
        },
        beforeDestroy () {
            this.filteredAgents = [];
        },
        computed: {
            ...mapGetters([
                'account',
                'getAgents',
                'getCommunityAgents',
                'getIsDownloadingCommunityAgents',
                'getIsConnectingToCommunityAgents'
            ]),
            communityAgents() {
                return this.getCommunityAgents;
            }
        },
        methods: {
            ...mapActions([
                'resetNewAgentSetup',
                'updateNewAgentSetup',
                'associateAgent',
                'clearClonedAgent',
                'downloadCommunityAgents',
                'connectCommunityAgent',
                'downloadAgents',
                'openUnkownAgent',
                'setSelectedPerson',
                'openModal'
            ]),
            searchInputChanged: _.debounce(function () {
                if (!this.form.email) {
                    this.filteredAgents = [];
                    this.hasMoreInfo = false;
                    return;
                }

                this.downloadCommunityAgents(this.form.email).then((res) => {
                    this.filterAgents();
                    this.hasMoreInfo = res.hasMore;
                });
                }, 300
            ),
            filterAgents() {
                let filterQuery = this.form.email.toLowerCase();

                if (this.communityAgents && this.communityAgents.agentDTOList) {
                    let filteredArray = this.communityAgents.agentDTOList.filter(function(agent){
                        return (agent.name && agent.name.toLowerCase().indexOf(filterQuery) !== -1) || agent.brandName && agent.brandName.toLowerCase().indexOf(filterQuery) !== -1 || agent.email && agent.email.toLowerCase().indexOf(filterQuery) !== -1;
                    });

                    // Checks if the user is already added, if sow adds flag helperAlreadyAdded
                    for (var i = 0; i < filteredArray.length; i++) {
                        for (var o = 0; o < this.getAgents.length; o++) {
                            if (filteredArray[i].id == this.getAgents[o].id) {
                                filteredArray[i].helperAlreadyAdded = true;
                                break;
                            }
                        }
                    }

                    this.filteredAgents = filteredArray;
                } else {
                    this.filteredAgents = [];
                }
            },
            invite(agent) {
                const agentClone = JSON.parse(JSON.stringify(agent));

                if (!agentClone.hasOwnProperty('email')) {
                    agentClone.email = this.form.email;
                }

                if (agentClone.hasOwnProperty('id')) {
                    delete agentClone.id;
                }

                // Set up our form fields. We'll store them for later usage
                this.clearClonedAgent();
                this.updateNewAgentSetup(agentClone);

                // Move on to create form
                this.clearForm();

                this.$router.push({ name: 'pluralo.agent.new' });
            },
            toggleWindow() {
                this.showWindow = !this.showWindow;
            },
            closeWindow() {
                this.clearForm();
                this.resetNewAgentSetup();
            },
            clearForm() {
                this.form.email = '';
                this.form.brandName = '';
                this.form.place = '';
                this.form.saveAndSend = true;
                this.searched = false;
                this.found = false;
                this.showWindow = false;
            },
            connectButtonLabel(agent) {
                if (agent.inviteStatus <= 5) {
                    return 'Connect';
                } else {
                    return this.peopleInviteStatus(agent).label.toLowerCase();
                }
            },
            connectButtonClass(agent) {
                if (agent.inviteStatus <= 5) {
                    return 'pointer';
                } else {
                    return 'notAllowed ' + this.peopleInviteStatus(agent).colorClass;
                }
            },
            openAgentInfo(agent) {
                this.openUnkownAgent({
                    agentId: agent.id
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    .floating-menu {
        left: auto;
        right: 16px;
        width: 20rem;
    }

    .agentList {
        max-height: 50vh;
        overflow-y: auto;
    }

    .connectStatusButton {
        min-width: 100px;
    }
</style>



// WEBPACK FOOTER //
// AgentInviteButton.vue?106b763c